<template>
  <div id="app">
    <v-app>
      <!-- <router-link to="/">Home</router-link>
      <router-link to="/line">Line Chart</router-link>
      <router-link to="/bar">Bar Chart</router-link> -->
      <router-view/>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.Chart {
  background: #f3f4f5;
  border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  margin:  25px 0;
}

.Chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color:  rgba(255, 0,0, 0.5);
  border-bottom: 1px solid #323d54;
}

.vgt-responsive {
  border-radius: 15px;
  -webkit-box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
}

.group {
  display: flex;
  flex: 1;
  justify-content: space-around;
}

.tcc-orange {
  color: #f4a146;
}

.tcc-orange-bg {
  background-color: #f4a146;
}

.vgt-center {
  text-align: center;
}

.vgt-center-award {
  text-align: center;
  color: red;
  font-weight: 900;
}

.vgt-table thead th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue